export enum CoordinationTransitionStatusColorEnum {
    REQ_UNKNOWN = 'medium',
    REQ_CREATE = 'medium',
    REQ_REMOVE = 'danger',
    REQ_ACCEPTANCE = 'success',
    REQ_REVIEW = 'primary',
    REQ_APPROVAL = 'success',
    REQ_COORDINATE = 'zomp',
    REQ_ACTIVATE = 'pistachio',
    REQ_DEACTIVATE = 'queenblue',
    REQ_COMPLETE = 'success',
    REQ_FINISH = 'dimmed',
    REQ_CANCEL = 'redsalsa',
    ACK_CANCEL = 'dimmed',
    REQ_SUSPEND = 'orangered',
    ACK_SUSPEND = 'dimmed',
    REQ_UNSUSPEND = 'pistachio',
    REQ_REJECT = 'danger',
}